export enum CustomerAccountType {
  PERSONAL = 'Personal',
  COMPANY = 'Company',
}

export const getCustomerAccountTypeLabel = (
  value: CustomerAccountType
): string => {
  switch (value) {
    case CustomerAccountType.PERSONAL:
      return $localize`Particulier`;
    case CustomerAccountType.COMPANY:
      return $localize`Entreprise`;
    default:
      return '';
  }
};
